import React from 'react';
import { TextField } from '../core-form-fields/BaseTextField';
import { cn } from '../../lib/utils';  // Add this import

interface TextFieldWithLengthProps {
  value: string;
  onChange: (value: string) => void;
  label: string;
  required?: boolean;
  minLength?: number;
  maxLength?: number;
  placeholder?: string;
  id?: string;
  multiline?: boolean;
  rows?: number;
  height?: string;
  className?: string;
}

export const TextFieldWithLength: React.FC<TextFieldWithLengthProps> = ({ 
  value, 
  onChange,
  label,
  required,
  minLength,
  maxLength,
  placeholder,
  id = label.toLowerCase().replace(/\s+/g, '-'),
  multiline,
  rows,
  className
}) => {
  return (
    <TextField
      id={id}
      label={label}
      type={multiline ? undefined : 'text'}
      value={value}
      onChange={onChange}
      required={required}
      validation={{
        minLength,
        maxLength,
        customValidation: (value) => undefined
      }}
      placeholder={placeholder}
      component={multiline ? 'textarea' : 'input'}
      rows={rows}
      className={cn(
        multiline && 'resize-none',
        className
      )}
    />
  );
};